import styled from 'styled-components'
import {maxWidth} from 'core/theme'

export const Wrapper = styled.a`
    width: 0px;
    height: 0px;
    position: fixed;
    margin-left: -680px;
    bottom: 90px;
    ${maxWidth.xlarge`
      margin-left: -37%;
    `}
    ${maxWidth.small`
      margin-left: -58%;
    `}
    z-index: 1;
    ${props => props.show ? `
      visibility: visible;
      opacity: 1;
      transition-delay: 0s;
    ` : `
      visibility: hidden;
      opacity: 0;
      transition: visibility 3s linear 5s, opacity 5s linear;
    `}
    svg {
        height: 60px;
        width: 60px;
        border-color: #0897fa;
        border-style: inset;
        border-radius: 40px;
        border-width: 3px;
        box-shadow: 0 0 20px 0 rgba(0,0,0,.35);
        animation: ${props => props.show && 'popup 0.7s;'}
    }

    @keyframes popup {
        0%{
            transform: scale(1);
        }
        50%{
            transform: scale(1.4);
        }
        60%{
            transform: scale(1.1);
        }
        70%{
            transform: scale(1.2);
        }
        80%{
            transform: scale(1);
        }
        90%{
            transform: scale(1.1);
        }
        100%{
            transform: scale(1);
        }
    }
`
export const CloseButton = styled.div`
    animation: cssAnimation 0s 0.6s forwards;
    visibility: hidden;

    width: 25px;
    height: 25px;
    position: absolute;
    top: -80px;
    left: 228px;
    margin-left: 45px;
    background-color: #ffffff;
    border-radius: 25px;
    opacity: 1;
    transition: all .4s cubic-bezier(.215,.61,.355,1);
    box-shadow: 0px 0px 30px 0px rgba(29, 96, 247, 0.5);
    cursor: pointer;
    & > span {
      background-color: #1e2134;
      display: block;
      height: 3px;
      border-radius: 3px;
      position: relative;
      transition: all .4s cubic-bezier(.215,.61,.355,1);
      position: absolute;
      top: 50%;
      margin-top: -2px;
      left: 5px;
      width: 16px;
      display: flex;
      justify-content: space-between;

      span {
        display: block;
        background-color: #ed7f00;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        position: absolute;
        left: 0;
        top: 0;
        transition: all .4s cubic-bezier(.215,.61,.355,1);
      }

      &.left {
        transform: rotate(45deg);
        transform-origin: center;
      }

      &.right {
        transform: rotate(-45deg);
        transform-origin: center;
      }
    }

    &:hover {
      & > span {
        background-color: #f3463d;
        transition: all .4s cubic-bezier(.215,.61,.355,1);
        span {
         transition: all .4s cubic-bezier(.215,.61,.355,1);
          background-color: #008ac9;
        }
      }
    }

    @keyframes cssAnimation {
        to   { visibility: visible; }
    }
`
export const MessageContainer = styled.div`
  width: 250px;
  height: 105px;
  position: absolute;
  top: -70px;
  margin-left: 40px;
  background-color: rgb(50, 150, 218);
  box-shadow: 0px 0px 30px 0px #666666;
  border-radius: 20px;
  border-bottom-left-radius: 0;
  z-index: -1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  label {
    color: white;
    cursor: pointer;
    font-weight: bold;
    max-width: 85%;
    word-break: break-word;
    padding: 5px;
    text-align: center;
  }
`
